if (!customElements.get("product-request-information")) {
  customElements.define(
    "product-request-information",
    class ProductRequestInformation extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.collapsed = this.getAttribute("expanded") === "false";
        this.toggleElement = this.querySelector(".product-request-information-toggle");
        this.form = this.closest("form");
        this.productPage = this.closest(".product-page");
        this.quoteQuantity = this.querySelector("[data-pm-quote-quantity]");
        this.onToggle = this.onToggle.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.toggleElement.addEventListener("click", this.onToggle);
        document.addEventListener("product:variant-change", this.onVariantChange);
        this.form?.addEventListener("submit", this.onSubmit);
        this.quoteQuantity?.addEventListener("input", () => {
          this.quoteQuantity.dataset.pmEdited = "true";
        });
        this.syncQuantity();
      }

      disconnectedCallback() {
        this.toggleElement?.removeEventListener("click", this.onToggle);
        document.removeEventListener("product:variant-change", this.onVariantChange);
        this.form?.removeEventListener("submit", this.onSubmit);
      }

      onToggle(event) {
        event.preventDefault();
        this.handleToggle();
      }

      collapse() {
        this.setAttribute("expanded", "false");
        this.toggleElement.setAttribute("aria-expanded", "false");
        this.collapsed = true;
      }

      expand() {
        this.setAttribute("expanded", "true");
        this.toggleElement.setAttribute("aria-expanded", "true");
        this.collapsed = false;
        this.syncQuantity();
        this.querySelector('input[name="contact[name]"]')?.focus();
      }

      handleToggle() {
        if (this.collapsed) {
          this.expand();
        } else {
          this.collapse();
        }
      }

      syncQuantity() {
        if (!this.quoteQuantity || this.quoteQuantity.dataset.pmEdited === "true") return;

        const productQuantity = this.productPage?.querySelector(
          'form[data-type="add-to-cart-form"] input[name="quantity"]',
        );
        if (productQuantity?.value) this.quoteQuantity.value = productQuantity.value;
      }

      onVariantChange(event) {
        if (!this.productPage || !event.detail?.variant) return;

        const variant = event.detail.variant;
        const variantTitle = variant.title === "Default Title" ? "" : variant.title || "";
        const titleField = this.querySelector("[data-pm-quote-variant-title]");
        const skuField = this.querySelector("[data-pm-quote-sku]");
        const idField = this.querySelector("[data-pm-quote-variant-id]");
        const label = this.querySelector("[data-pm-quote-variant-label]");

        if (titleField) titleField.value = variant.title || "";
        if (skuField) skuField.value = variant.sku || "";
        if (idField) idField.value = variant.id || "";
        if (label) label.textContent = variantTitle ? ` — ${variantTitle}` : "";
      }

      onSubmit() {
        this.syncQuantity();
      }
    },
  );
}
